var STORE_KEY = "ONE_ACCOUNT_ROLE_META";
export function validateRoleInfo(roleInfo) {
    var res = typeof roleInfo === "object" &&
        typeof roleInfo["channelMasterId"] === "number";
    //  && typeof roleInfo["token"] === "string"
    if (!res) {
        console.error('[@hg/one-account] user info has incorrect format, should be like "{ channelMasterId: number, token: string }"');
    }
    return res;
}
export function validateRoleMeta(roleMeta) {
    var res = typeof roleMeta === "object" &&
        typeof roleMeta["token"] === "string" &&
        typeof roleMeta["verifier"] === "string" &&
        typeof roleMeta["channel"] === "string";
    if (!res) {
        console.error('[@hg/one-account] user info has incorrect format, should be like "{ channelMasterId: number, token: string }"');
    }
    return res;
}
/**
 * RoleMeta 记录业务上最近使用的角色信息，用来判断当前账号的一致性
 *
 * @export
 * @return {*}  {(RoleMeta | null)}
 */
export function getRoleMeta(option) {
    var path = (option === null || option === void 0 ? void 0 : option.site) && getSitePath(option.site);
    var storedKey = path ? "".concat(STORE_KEY, ":").concat(path) : STORE_KEY;
    var dataStr = localStorage.getItem(storedKey);
    if (!dataStr)
        return null;
    try {
        var data = JSON.parse(dataStr);
        if (validateRoleMeta(data))
            return data;
    }
    catch (err) { }
    localStorage.removeItem(storedKey);
    return null;
}
export function setRoleMeta(roleMeta, option) {
    var path = (option === null || option === void 0 ? void 0 : option.site) && getSitePath(option.site);
    var storedKey = path ? "".concat(STORE_KEY, ":").concat(path) : STORE_KEY;
    localStorage.setItem(storedKey, JSON.stringify(roleMeta));
}
export function clearRoleMeta(option) {
    var path = (option === null || option === void 0 ? void 0 : option.site) && getSitePath(option.site);
    var storedKey = path ? "".concat(STORE_KEY, ":").concat(path) : STORE_KEY;
    localStorage.removeItem(storedKey);
}
function getSitePath(site) {
    try {
        var url = new URL(site);
        return url.pathname;
    }
    catch (err) {
        console.warn("[@hg/one-account] Passed site \"".concat(site, "\" not match an url format, site option will be ignored."));
        return null;
    }
}
